export default __webpack_public_path__ + "static/media/[RGB] BOX2HELP-plava.1f2e1125.png";